import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';

import * as moment from 'moment';
import * as cloneDeep from 'lodash/cloneDeep';

import { CaptureSignatureComponent } from '../../../capture-signature/capture-signature.component';
import { PurchaseOrderManagerService } from '../../../../../services/purchase-order/purchase-order-manager.service';
import { PurchaseOrderPDFComponent } from '../../../purchase-order-pdf/purchase-order-pdf.component';
import { ThemeManager } from '../../../../../managers/theme.manager';
import { CurrencyConvertPipe } from 'src/app/services/custom-currency.pipe';
import { PurchaseOrderPaymentType } from 'src/app/services/purchase-order/purchase-order.model';
import { PaymentTypesSelectionComponent } from '../../payment-types-selection/payment-types-selection.component';
import { UiUtils } from 'src/app/shared-ui/utils/ui-utils';
import { AuthManagerService } from 'src/app/services/auth/auth-manager.service';
import { VehicleInfoComponent } from '../../vehicle-info/vehicle-info/vehicle-info.component';
import { LocalCacheManager } from 'src/app/managers/local-cache.manager';
import { Contact } from 'src/app/services/vendor/contact.model';

@Component({
    selector: 'ls-texas-compliance-page',
    templateUrl: './texas-compliance-page.component.html',
    styleUrls: [ './texas-compliance-page.component.less' ]
})
export class TexasCompliancePageComponent implements OnInit
{
    @ViewChild('signature', { static: false }) signature: CaptureSignatureComponent;

    @Output() signatureCompleted = new EventEmitter<boolean>();
    userCurrency: string = LocalCacheManager.currency;
    timeZones = UiUtils.timeZones;
    selectedTimezone: any = null;
    // name = '';

    idNum = '';
    idState = '';
    contactValid: boolean;
    selectedContact: Contact;
    headerText = 'Purchase Agreement';

    buyerText = 'Buyer:';

    declaration1 = 'I, the undersigned, hereby certify that I am the legal owner of all the merchandise sold. I have';
    declaration2 = 'an active license, certificate, registration, documentation showing my business entity status at';
    declaration3 = 'point of sale. I sell regulated material and/or regulated metal in the ordinary course of my';
    declaration4 = 'business and I acknowledge this receipt as payment in full.';

    sellerInfoHeaderText = 'Seller:';
    idText = 'ID or DL # _______________________________________________';
    signatureText = 'Signature ______________________________________________________';
    printText = 'Print _________________________________________________________';
    dateText = 'Date ___________________________';
    makeText = 'Make ___________________________';
    modelText = 'Model ___________________________';
    colorText = 'Color ________________________';
    numberText = 'Number _______________________________________________';
    stateText = 'State ______________';

    selectedPaymentTypes: PurchaseOrderPaymentType[] = [];
    columns = [
        { title: 'PO #', widthPercent: 15, rowspan: 2 },
        { title: 'Description', widthPercent: 15 },
        { title: 'Quantity', widthPercent: 10 },
        { title: 'Purchase Price', widthPercent: 25 },
        { title: 'Sum', widthPercent: 15, rowspan: 2},
        { title: 'Adjustment', widthPercent: 15},
        { title: 'Total', widthPercent: 15, rowspan: 2}
    ];

    ThemeManager = ThemeManager;

    constructor(public poManager: PurchaseOrderManagerService, private currencyPipe: CurrencyConvertPipe, private authManager: AuthManagerService) { }

    ngOnInit(): void
    {
        this.clearSignatures();
        this.selectedTimezone = UiUtils.timeZones.find(x => x.fullName.toLocaleUpperCase() == this.authManager.currentUser.timeZone.toLocaleUpperCase())
    }
    adjustmentChange() {
        this.poManager.current.totalAdjusted = this.poManager.current.totalPrice + this.poManager.current.totalAdjustment;
    }
    onSelectedContactChanged(event: any): void
    {
        this.selectedContact = event.value;
        this.contactValid = this.selectedContact.isContactValidForPO;
        // if (!this.selectedContact.isContactValidForPO) {
        //     this.messageService.add({ severity: 'error', summary: 'Invalid Contact', detail: `Contact has invalid driver's license information and cannot be selected.` });
        //     setTimeout(() => {
        //         this.idNum = '';
        //         this.idState = '';
        //         this.poManager.current.print = '';
        //         this.selectedContact = undefined;
        //     }, 100);
        //     return;
        // }
        this.idNum = this.selectedContact.driversLicenseNumber ?? '';
        this.idState = this.selectedContact.driversLicenseState ?? '';
        this.poManager.current.print = this.selectedContact.fullName;
    }
    generateSignaturePage(parent: PurchaseOrderPDFComponent): void
    {
        if(parent.po.isLocked){    
            this.idNum = parent.po.contactLicenseNumber ?? 'N/A';
            this.idState = parent.po.contactState ?? 'N/A'

            this.selectedPaymentTypes = []
            if(parent.po.totalCash)
                this.selectedPaymentTypes.push(1);
            if(parent.po.totalCheck)
                this.selectedPaymentTypes.push(2);
            if(parent.po.totalWire)
                this.selectedPaymentTypes.push(4);
        }

        // Add Title
        parent.outputComplianceHeader(this.headerText);

        // Use "table headers" to create the pseudo-table
        parent.createTableHeader(this.columns, true, false);;
        const columnOutput = cloneDeep(this.columns);
        columnOutput[0].title = parent.po.number;
        columnOutput[1].title = 'Converters';
        columnOutput[2].title = parent.po.totalNumConverters.toString();
        columnOutput[3].title = this.currencyPipe.transform(parent.po.totalConvertersPrice, parent.po.currency);
        columnOutput[4].title = this.currencyPipe.transform(parent.po.totalPrice, parent.po.currency);
        columnOutput[5].title = this.currencyPipe.transform(parent.po.catsAdjustment, parent.po.currency);
        columnOutput[6].title = this.currencyPipe.transform(parent.po.totalPrice + (parent.po.catsAdjustment ?? 0) + (parent.po.nonFerrousAdjustment ?? 0), parent.po.currency);
        parent.createTableRow(columnOutput, 0, true, false);
        columnOutput[0].title = parent.po.number;
        columnOutput[1].title = 'Non-Ferrous';
        columnOutput[2].title = parent.po.numMiscellaneous.toString();
        columnOutput[3].title = this.currencyPipe.transform(parent.po.totalMiscPrice, parent.po.currency, true);
        columnOutput[5].title = this.currencyPipe.transform(parent.po.nonFerrousAdjustment, parent.po.currency, true);
        parent.createTableRow(columnOutput, 1, true, false);
        parent.result.bottomOfOutput += parent.lineHeight;
        
        VehicleInfoComponent.addToPdf(parent);

        parent.result.bottomOfOutput += parent.lineHeight * 1.5;
        parent.outputTextLine('Payment type selected:');
        parent.result.bottomOfOutput += (parent.lineHeight / 2);
        let margin = 10;
        for (const paymentType of PaymentTypesSelectionComponent.paymentTypes)
        {
            parent.outputCheckbox(margin, this.selectedPaymentTypes.some(pt => pt === paymentType.value));
            if(paymentType.value == 1) {
                parent.result.bottomOfOutput += parent.lineHeight
                parent.outputText('Total: ' + this.currencyPipe.transform(this.poManager.current.totalCash, parent.po.currency, true), margin)
                parent.result.bottomOfOutput -= parent.lineHeight
            }
            if(paymentType.value == 2) {
                parent.result.bottomOfOutput += parent.lineHeight;
                parent.outputText('Total: ' + this.currencyPipe.transform(this.poManager.current.totalCheck, parent.po.currency, true), margin)
                parent.result.bottomOfOutput -= parent.lineHeight
                
                if(this.poManager.current.checkNumber != null && this.poManager.current.checkNumber != '') {
                    parent.result.bottomOfOutput += (parent.lineHeight * 2)
                    parent.outputText('Number: ' + this.poManager.current.checkNumber, margin)
                    parent.result.bottomOfOutput -= (parent.lineHeight * 2)
                }
            }
            if(paymentType.value == 4) {
                parent.result.bottomOfOutput += parent.lineHeight
                parent.outputText('Total: ' + this.currencyPipe.transform(this.poManager.current.totalWire, parent.po.currency, true), margin)
                parent.result.bottomOfOutput -= parent.lineHeight
            }
            margin += 15;
            parent.outputText(paymentType.title, margin);
            margin += parent.textWidth(paymentType.title) + 120;
        }
parent.result.bottomOfOutput += parent.lineHeight * 3;
        parent.outputTextLine(this.sellerInfoHeaderText);
        parent.result.bottomOfOutput += parent.lineHeight * 1.1;
        parent.outputText(`${this.idText}  ${this.stateText}`);
        parent.outputText(this.idNum ?? 'N/A', parent.textWidth(this.removeUnderscores(this.idText) + 5));
        parent.outputTextLine(this.idState ?? 'N/A', parent.textWidth(`${this.idText}  `) +
        parent.textWidth(this.removeUnderscores(this.stateText) + 5));
        
        parent.result.bottomOfOutput += parent.lineHeight * 3;
        parent.outputTextLine(this.buyerText);
        parent.result.bottomOfOutput += parent.lineHeight;
        parent.outputTextLine(parent.po.buyerName);
        parent.outputTextLine(parent.po.location.address);
        parent.outputTextLine(`${parent.po.location.city}, ${parent.po.location.state}  ${parent.po.location.zip}`);

        parent.result.bottomOfOutput += parent.lineHeight * 2;
        parent.outputTextLine(this.declaration1);
        parent.outputTextLine(this.declaration2);
        parent.outputTextLine(this.declaration3);
        parent.outputTextLine(this.declaration4);

        const vendor = parent.po.vendor;
        parent.result.bottomOfOutput += parent.lineHeight * 2;
        parent.outputTextLine(this.sellerInfoHeaderText);
        parent.result.bottomOfOutput += parent.lineHeight;
        parent.outputTextLine(vendor.name);
        parent.outputTextLine(vendor.address);
        parent.outputTextLine(`${vendor.city}, ${vendor.state}  ${vendor.zip}`);

        // tslint:disable:max-line-length

        parent.result.bottomOfOutput += parent.lineHeight * 2;
        const imageHeight = parent.lineHeight * 2;
        parent.outputText(`${this.signatureText}  ${this.dateText}`);
        if(parent.po.isLocked) {
            parent.outputImage(parent.po.signaturePageUrl, 'PNG', parent.leftMargin + parent.textWidth(this.removeUnderscores(this.signatureText)), imageHeight * 5, imageHeight);
        } else {
            const widthToHeightRatio = this.signature.widthToHeightRatio;
            parent.outputImage(this.signature.signature, 'PNG', parent.leftMargin + parent.textWidth(this.removeUnderscores(this.signatureText)), imageHeight * widthToHeightRatio, imageHeight);
        }
        parent.outputTextLine(moment(this.poManager.current.purchaseDate).format('MM-DD-yyyy'), parent.textWidth(`${this.signatureText}  `) +
            parent.textWidth(this.removeUnderscores(this.dateText) + 5));

        parent.result.bottomOfOutput += parent.lineHeight * 2;
        parent.outputText(this.printText);
        parent.outputText(this.poManager.current.print, parent.textWidth(this.removeUnderscores(this.printText) + 5));
        // tslint:enable:max-line-length

        this.selectedPaymentTypes = [];
    }
    get sellerSignatureFile(): File {
        return this.signature.getSignatureFile(`po_${this.poManager.current.id}_seller_signature.png`);
    }
    removeUnderscores(text: string): string
    {
        return text.replace(/_/g, '');
    }

    clearSignatures(): void
    {
        this.signature?.clear();
    }

    onCancel(): void
    {
        VehicleInfoComponent.clearInfo();
        this.selectedPaymentTypes = []
        this.signatureCompleted.emit(false);
    }

    onSave(): void
    {
        this.poManager.current.timeZone = this.selectedTimezone.fullName;
        this.signatureCompleted.emit(true);
    }
}
